/**
 *
 */
class ToothPosition {
  constructor (id, x, y) {
    this._id = id
    this._x = x
    this._y = y
  }

  /**
   *
   * @return {string}
   */
  get id () {
    return this._id
  }

  /**
   *
   * @return {Number}
   */
  get x () {
    return this._x
  }

  /**
   *
   * @return {Number}
   */
  get y () {
    return this._y
  }
}

class Positions {
  /**
   *
   * @param positions {[]<ToothPosition>}
   */
  constructor (positions = []) {
    this._positionsMap = new Map()
    for (const position of positions) {
      this._positionsMap.set(position.id, position)
    }
  }

  /**
   *
   * @param id {String}
   */
  getPositionFor (id) {
    return this._positionsMap.get(id)
  }
}

export default Positions

export { ToothPosition }



// WEBPACK FOOTER //
// ./src/components/general/TeethView/ToothPosition.js